import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import { createMuiTheme, ThemeOptions } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createMuiTheme" {
  interface Theme {
    drawer: {
      width: React.CSSProperties["width"];
      breakpoint: Breakpoint;
    };
  }
  interface ThemeOptions {
    drawer?: {
      width?: React.CSSProperties["width"];
      breakpoint?: Breakpoint;
    };
    miCuenta?: {
      paper: any;
      title: any;
    };
  }
}

export default function createMyTheme(options?: ThemeOptions) {
  return createMuiTheme({
    drawer: {
      width: 315,
      breakpoint: "lg",
    },
    palette: {
      primary: {
        main: "#004C81",
        light: "#004C81",
      },
      secondary: {
        main: "#0F76AF",
      },
    },
    typography: {
      fontFamily: "Maven Pro",
    },
    ...options,
  });
}
